// This file is automatically generated by `generated_js` task. Any changes will be lost
/* tslint:disable */
export const GoCDVersion = {
  "version": "25.4.0",
  "buildNumber": "21793",
  "gitSha": "c8358258163d7b9833ab3b18a2f459999936b03a",
  "fullVersion": "25.4.0-21793",
  "formattedVersion": "25.4.0 (21793-c8358258163d7b9833ab3b18a2f459999936b03a)"
}


function stripLeadingPrefix(suffix: string, prefix: string) {
  if (suffix.startsWith(prefix)) {
      suffix = suffix.substring(1);
  }
  return suffix;
}

export function docsUrl(suffix: string = '') {
  return `https://docs.gocd.org/25.4.0/${stripLeadingPrefix(suffix, '/')}`
}

export function apiDocsUrl(suffix: string = '') {
  return `https://api.gocd.org/25.4.0/${stripLeadingPrefix(suffix, '#')}`
}
    
